import React from 'react';
import { useToast, Button, Box, Text } from "@chakra-ui/react"

export const SuccessToast = function SuccessFunction() {
    const toast = useToast()
    return (
      <Button w='120px' h='50px' colorScheme='whatsapp'
        onClick={() =>
          toast({
            position: 'bottom-left',
            title: 'Thank You for Your Click.',
            description: 'Your Response has been recorded. Trust me.',
            status: "success",
            duration: 5000,
            isClosable: true,
          })
        }
      >
        Submit
      </Button>
    )
  }

export const InfoToast = function InfoFunction() {
    const toast = useToast()
    return (
      <Button w='120px' h='50px' colorScheme='telegram'
        onClick={() =>
          toast({
            position: 'bottom-left',
            title: "Advice.",
            description: "Skip this bit and get into the cool things.",
            status: "info",
            duration: 5000,
            isClosable: true,
          })
        }
      >
        Advice
      </Button>
    )
  }

export const ErrorToast = function ErrorFunction() {
    const toast = useToast()
    return (
      <Button w='120px' h='50px' colorScheme='red'
        onClick={() =>
          toast({
            position: 'bottom-left',
            title: "An error occurred.",
            description: "There's no going back.",
            status: "error",
            duration: 5000,
            isClosable: true,
          })
        }
      >
        Revert
      </Button>
    )
  }

export const CustomToast = function CustomFunction() {
    const toast = useToast()
    return (
      <Button
        onClick={() =>
          toast({
            position: "bottom-left",
            render: () => (
              <Box color="white" p={5} bg="blue.500">
                "Hello World"
              </Box>
            ),
          })
        }
      >
        Show Toast
      </Button>
    )
  }

